import { render, staticRenderFns } from "./GetAudienceModal.vue?vue&type=template&id=bcd0f8da&scoped=true"
import script from "./GetAudienceModal.vue?vue&type=script&lang=js"
export * from "./GetAudienceModal.vue?vue&type=script&lang=js"
import style0 from "./GetAudienceModal.vue?vue&type=style&index=0&id=bcd0f8da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd0f8da",
  null
  
)

export default component.exports